export const toFluidPixelValue = ({ minValue, maxValue, maxBreakpoint, minBreakpoint }) => {
    if (minBreakpoint === maxBreakpoint || minValue === maxValue) {
        return `${minValue}px`;
    }
    return `calc(${minValue}px + (${maxValue} - ${minValue}) * ((100vw - ${minBreakpoint}px) / (${maxBreakpoint} - ${minBreakpoint})))`;
};
export const toPixelValue = (t) => `${t}px`;
